import React from 'react'
import { Flex } from '@src/components/Boxes'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import { getRelativePath } from '@src/utils/routes'
import { mediaQueries } from '@src/styles/theme'

const Header = styled('h2')`
  font-size: 16px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);
  color: #fff;
  line-height: 1.1;
  font-weight: 200;
  z-index: 3;
  text-align: center;
  margin-top: 0px;
  ${mediaQueries[1]} {
    font-size: 24px;
  }
`
const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  color: #fff;
  font-size: 24px;
  z-index: 999;
  transition: opacity 0.4s;
  background: transparent;
  outline: 0;
  border: 0;
  cursor: pointer;
  ${mediaQueries[1]} {
    font-size: 40px;
    width: 55px;
    height: 55px;
  }`

type SchoolClosureBannerSectionProps = {
  closeFunction: () => void
}

const SchoolClosureBannerSection: React.FC = ({ closeFunction }: SchoolClosureBannerSectionProps) => {
  return (

    <Flex
      padding="12px"
      position="relative"
      justifyContent="center"
      alignItems="center"
      backgroundColor={'#00aeef'}
      width="100%"
      overflow="hidden"
      height="90px"
    >
      <Link to={getRelativePath('/remotelearning')}>
        <Header>
          If your community is preparing for school closures, we can help.
          <br />
          ClassDojo is a free communication platform: <u>learn more about remote learning on ClassDojo</u>
        </Header>
      </Link>
      <CloseButton onClick={() => closeFunction()}>×</CloseButton>
    </Flex>
  )
}

export default SchoolClosureBannerSection
